exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tooltip-custom {\n    padding: 3px 8px;\n    color: #fff;\n    text-align: center;\n    background-color: #333;\n    border-radius: 4px;\n}\n\n", ""]);

// exports
